import { render, staticRenderFns } from "./itinerary_hotel_fake.vue?vue&type=template&id=437231b1&"
import script from "./itinerary_hotel_fake.vue?vue&type=script&lang=js&"
export * from "./itinerary_hotel_fake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260303093641/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437231b1')) {
      api.createRecord('437231b1', component.options)
    } else {
      api.reload('437231b1', component.options)
    }
    module.hot.accept("./itinerary_hotel_fake.vue?vue&type=template&id=437231b1&", function () {
      api.rerender('437231b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_hotel_fake.vue"
export default component.exports